import React from 'react';

import {
  ProjectType, TeamPermission,
  useProjectDatesFieldsService
} from 'nekst-api';
import { withAccessCheck } from 'authorization-scope';
import { BaseSetProjectDatesFieldsForm } from './BaseSetProjectDtesFieldsForm';
import { Separator } from "features/nekst-widgets";

function SetProjectDatesFieldsForm(
  props: {
    projectType: ProjectType,
  }
) {
  const projectDatesFieldsService = useProjectDatesFieldsService();

  return (
    <>
      <BaseSetProjectDatesFieldsForm
        projectType={props.projectType}
        submitFormFunc={async (data) => {
          await projectDatesFieldsService.updateProjectDatesFields(props.projectType, data);
        }}
      />
      <Separator />
    </>
  );
}

export default withAccessCheck(
  SetProjectDatesFieldsForm,
  TeamPermission.MANAGE_AI_TRAINING_DATA
);
